import { useState, useCallback } from "react";
import AddEmailModal from "components/modals/creative-modal/components/add-email-modal";
import { ConfirmationDialog } from "ui/confirmation-dialog";

interface UseAddEmailModalProps {
  folderId?: string;
}

export const useAddEmailModal = ({ folderId }: UseAddEmailModalProps = {}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isConfirmExitOpen, setIsConfirmExitOpen] = useState(false);

  const openAddEmailModal = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeAddEmailModal = useCallback(() => {
    setIsOpen(false);
    setIsConfirmExitOpen(false);
  }, []);

  const openConfirmExit = useCallback(() => {
    setIsConfirmExitOpen(true);
  }, []);

  const closeConfirmExit = useCallback(() => {
    setIsConfirmExitOpen(false);
  }, []);

  const handleConfirmExit = useCallback(() => {
    closeAddEmailModal();
  }, [closeAddEmailModal]);

  const addEmailModalMarkup = (
    <>
      {isOpen && (
        <AddEmailModal
          isOpen={true}
          onClose={closeAddEmailModal}
          onConfirmClose={openConfirmExit}
          folderId={folderId}
        />
      )}

      {isConfirmExitOpen && (
        <ConfirmationDialog
          open
          onClose={closeConfirmExit}
          onConfirm={handleConfirmExit}
          intent="warning"
          closable={false}
          headline="Leave without saving?"
          message="All unsaved changes will be lost."
          cancelButtonText="Continue editing"
          confirmButtonText="Leave setup"
        />
      )}
    </>
  );

  return {
    openAddEmailModal,
    addEmailModalMarkup,
  };
};
